export const TEXT_DISPLAY_NAME = "Text";
